import styled from 'styled-components';

import { Box } from '@mui/material';
import { SubRollingOfferUiProps } from 'templates/RollingOffer/shared/types';
import { motion } from 'framer-motion';
import {
  arrowHeightWidth,
  containerPadding,
} from 'templates/RollingOffer/shared/utils';

export interface StyledSubRollingOfferProps extends SubRollingOfferUiProps {
  clickable?: boolean;
}

export const StyledArrowWrapper = styled(Box)<{
  height: number;
  paddingLeft: string;
  paddingRight: string;
}>`
  height: ${({ height }) => height}px;
  padding-left: ${({ paddingLeft }) => paddingLeft};
  padding-right: ${({ paddingRight }) => paddingRight};
  align-items: center;
  display: flex;
`;

export const StyledSubOfferWrapper = styled(motion.div)`
  width: calc(50% - ${arrowHeightWidth / 2 + containerPadding}px);
  position: absolute;
  display: flex;
  z-index: 1;
`;
